const AiContentMarketingJourney = () => {
  return (
    <>
      <div className="ai-wt-journey-area pl-20 pr-20">
        <div className="container-fluid">
          <div className="ai-wt-body-bg-2 pt-120 position-relative z-1 overflow-hidden">
            <img
              src="assets/img/ai-wt-home/shape/step-1.png"
              alt=""
              className="shape-1 p-5 img-fluid position-absolute right-0 top-0 z--1"
            />
            <div className="container">
              <div className="row justify-content-center">
                <div className="col-xl-5 col-lg-7">
                  <div className="text-center">
                    <h2 className="aiwt-title text-black ff-risk-pri fs-48">
                      Easy Journey in Just 3_
                      <span className="ai-wt-brand-text fw-400">
                        Simple Steps
                      </span>
                    </h2>
                  </div>
                </div>
              </div>
              <div className="ai-wt-journey-tab pt-40 pb-80 ai-wt-bb-style position-relative z-1">
                <img
                  src="assets/img/ai-wt-home/shape/step-2.png"
                  alt=""
                  className="shape-2 img-fluid position-absolute z--1"
                />
                <div className="row align-items-center">
                  <div className="col-xl-6">
                    <div className="tab-content" id="nav-tabContent">
                      <div
                        className="tab-pane fade active show"
                        id="ai-tab-1"
                        role="tabpanel"
                      >
                        <div className="ai-wt-tab-content">
                          <img
                            className="w-100 img-fluid"
                            src="assets/img/ai-wt-home/tab-1.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="ai-tab-2"
                        role="tabpanel"
                      >
                        <div className="ai-wt-tab-content">
                          <img
                            className="w-100 img-fluid"
                            src="assets/img/ai-wt-home/tab-1.png"
                            alt=""
                          />
                        </div>
                      </div>
                      <div
                        className="tab-pane fade"
                        id="ai-tab-3"
                        role="tabpanel"
                      >
                        <div className="ai-wt-tab-content">
                          <img
                            className="w-100 img-fluid"
                            src="assets/img/ai-wt-home/tab-1.png"
                            alt=""
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xxl-5  col-xl-6">
                    <ul
                      className="nav flex-column mb-0"
                      id="nav-tab"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <a
                          className="nav-link active"
                          href="#ai-tab-1"
                          data-bs-toggle="tab"
                          data-bs-target="#ai-tab-1"
                          role="tab"
                          aria-selected="false"
                        >
                          <div className="ai-wt-tab-nav p-4 rounded-16">
                            <h6 className="text-black ff-risk-pri fw-bolder fs-20">
                              Click on Join Now
                            </h6>
                            <p className="mb-0">
                              AI writing tool for 1-click SEO Optimizes articles
                              blog posts & affiliate content. Available in 48
                              auto- auto posted to with AI Images.
                            </p>
                          </div>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href="#ai-tab-2"
                          data-bs-toggle="tab"
                          data-bs-target="#ai-tab-2"
                          role="tab"
                          aria-selected="false"
                        >
                          <div className="ai-wt-tab-nav p-4 rounded-16">
                            <h6 className="text-black ff-risk-pri fw-bolder fs-20">
                              Get Your Unique Link
                            </h6>
                            <p className="mb-0">
                              AI writing tool for 1-click SEO Optimizes articles
                              blog posts & affiliate content. Available in 48
                              auto- auto posted to with AI Images.
                            </p>
                          </div>
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          className="nav-link"
                          href="#ai-tab-3"
                          data-bs-toggle="tab"
                          data-bs-target="#ai-tab-3"
                          role="tab"
                          aria-selected="false"
                        >
                          <div className="ai-wt-tab-nav p-4 rounded-16">
                            <h6 className="text-black ff-risk-pri fw-bolder fs-20">
                              Click on Join Now
                            </h6>
                            <p className="mb-0">
                              AI writing tool for 1-click SEO Optimizes articles
                              blog posts & affiliate content. Available in 48
                              auto- auto posted to with AI Images.
                            </p>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AiContentMarketingJourney;
